var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherConditionsAlt = function SvgWeatherConditionsAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 57.16 60.01",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weather_conditions_alt_svg2__a",
    x1: -12.26,
    x2: 24.59,
    y1: 34.96,
    y2: -7.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__b",
    x1: 14.13,
    x2: 50.98,
    y1: 57.7,
    y2: 14.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__c",
    x1: 18.98,
    x2: 55.83,
    y1: 61.87,
    y2: 19.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__d",
    x1: 21.3,
    x2: 58.14,
    y1: 63.87,
    y2: 21.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__e",
    x1: -1.03,
    x2: 35.82,
    y1: 44.63,
    y2: 1.86
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__f",
    x1: 0.95,
    x2: 37.8,
    y1: 46.34,
    y2: 3.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__g",
    x1: 2.93,
    x2: 39.77,
    y1: 48.04,
    y2: 5.27
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__h",
    x1: 9.15,
    x2: 46,
    y1: 53.4,
    y2: 10.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__i",
    x1: 10.35,
    x2: 47.19,
    y1: 54.43,
    y2: 11.66
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__j",
    x1: -16.26,
    x2: 20.59,
    y1: 31.51,
    y2: -11.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__k",
    x1: -18.26,
    x2: 18.59,
    y1: 29.79,
    y2: -12.99,
    gradientTransform: "rotate(60 2.228 6)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__l",
    x1: -14.31,
    x2: 22.54,
    y1: 33.2,
    y2: -9.58,
    gradientTransform: "rotate(30 2.232 14.002)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__m",
    x1: -8.35,
    x2: 28.5,
    y1: 38.33,
    y2: -4.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__n",
    x1: -6.35,
    x2: 30.5,
    y1: 40.05,
    y2: -2.72,
    gradientTransform: "rotate(60 16.087 14.003)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__o",
    x1: -10.31,
    x2: 26.54,
    y1: 36.64,
    y2: -6.13,
    gradientTransform: "rotate(30 16.085 5.99)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__p",
    x1: -6.2,
    x2: 30.65,
    y1: 40.18,
    y2: -2.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__q",
    x1: -4.22,
    x2: 32.63,
    y1: 41.89,
    y2: -0.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_alt_svg2__a",
    id: "weather_conditions_alt_svg2__r",
    x1: -2.24,
    x2: 34.61,
    y1: 43.59,
    y2: 0.81
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M9.16 15h.19a5.013 5.013 0 0 0 4.92-5.1 5.013 5.013 0 0 0-5.1-4.92 5.013 5.013 0 0 0-4.92 5.1A5.016 5.016 0 0 0 9.17 15Zm-2.2-7.04c.54-.59 1.29-.93 2.09-.96h.11c1.66 0 3 1.35 3 3s-1.35 3-3 3-3-1.35-3-3c0-.76.29-1.49.8-2.04",
    style: {
      fill: "url(#weather_conditions_alt_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.16 24c0-2.21-1.79-4-4-4s-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2h-7v2h7c2.21 0 4-1.79 4-4",
    style: {
      fill: "url(#weather_conditions_alt_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.16 24c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2h-17v2h17c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      fill: "url(#weather_conditions_alt_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.16 34h-13v2h13c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2h-2c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4",
    style: {
      fill: "url(#weather_conditions_alt_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 26h12v2h-12z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 30h12v2h-12z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 34h12v2h-12z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.16 39.79V6c0-3.31-2.69-6-6-6s-6 2.69-6 6v33.79c-5.09 3.31-6.53 10.13-3.22 15.22s10.13 6.53 15.22 3.22 6.53-10.13 3.22-15.22a11 11 0 0 0-3.22-3.22m1.8 13.71a8.97 8.97 0 0 1-7.8 4.5c-4.97 0-9-4.02-9-8.99 0-3.22 1.71-6.19 4.5-7.8a1 1 0 0 0 .5-.86V6c0-2.21 1.79-4 4-4s4 1.79 4 4v34.35c0 .36.19.69.5.86 4.3 2.48 5.78 7.98 3.3 12.28Z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.16 44.1V12h-2v32.1a4.997 4.997 0 0 0-3.9 5.9c.55 2.71 3.19 4.45 5.9 3.9s4.45-3.19 3.9-5.9a5.01 5.01 0 0 0-3.9-3.9m-1 7.9c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3",
    style: {
      fill: "url(#weather_conditions_alt_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 0h2v4h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23 4h2v4h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__k)"
    },
    transform: "rotate(-60 2.23 5.998)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.23 13h4v2h-4z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__l)"
    },
    transform: "rotate(-30 2.23 13.997)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16 16h2v4h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09 12h2v4h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__n)"
    },
    transform: "rotate(-60 16.095 14.003)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.09 5h4v2h-4z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__o)"
    },
    transform: "rotate(-30 16.094 5.992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16 26h2v2h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16 30h2v2h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16 34h2v2h-2z",
    style: {
      fill: "url(#weather_conditions_alt_svg2__r)"
    }
  }));
};
export default SvgWeatherConditionsAlt;